// x-image-slide.js

/*
This script:
- Creates prev/next buttons for horizontal scroll.
- Checks for horizontal overflow and adds prev/next buttons when needed.
- Sets ?alt=listing size on slide images.
- Needs x-image-zoom.js for zoom.
	- Default zoom is one level.
	- Add "deep-zoomable" class to image-slide container to enable deep zoom.
*/

export default function xImageSlide() {
	if (document.body.id !== "vrtx-structured-article") return;

	const imageSlideAll = document.querySelectorAll(".image-slide");
	if (!imageSlideAll.length) return;

	const isEnglish = document.documentElement.lang === "en";

	imageSlideAll.forEach(imageSlide => {
		// Enable keyboard scroll
		imageSlide.tabIndex = 0;

		const slideFiguresAll = imageSlide.querySelectorAll("figure");
		if (!slideFiguresAll.length) return;

		// Create wrapper with prev/next buttons
		const prevNextButtonWrapper = document.createElement("div");
		const nextButton = document.createElement("button");
		const prevButton = document.createElement("button");

		nextButton.className = "next";
		nextButton.setAttribute("aria-label", isEnglish ? "Next" : "Neste");
		prevButton.className = "prev";
		prevButton.setAttribute("aria-label", isEnglish ? "Previous" : "Forrige");

		prevNextButtonWrapper.className = "image-slide-prev-next";
		prevNextButtonWrapper.append(prevButton, nextButton);
		imageSlide.before(prevNextButtonWrapper);

		// Set listing size for all slide images
		slideFiguresAll.forEach(slideFigure => {
			const slideImage = slideFigure.querySelector("img");
			if (!slideImage) return;

			const imageUrl = new URL(slideImage.src);
			if (imageUrl.searchParams.get("alt") !== "listing") {
				imageUrl.searchParams.set("alt", "listing");
				slideImage.src = imageUrl.toString();
			}
		});

		// Get scroll distance between items
		function getItemDistance() {
			if (slideFiguresAll.length >= 2) {
				return slideFiguresAll[1].offsetLeft - slideFiguresAll[0].offsetLeft;
			}
		}

		// Scroll handlers
		nextButton.addEventListener("click", () => {
			const itemDistance = getItemDistance();
			if (itemDistance) {
				imageSlide.scrollTo({
					left: imageSlide.scrollLeft + itemDistance,
					behavior: "smooth"
				});
			}
		});

		prevButton.addEventListener("click", () => {
			const itemDistance = getItemDistance();
			if (itemDistance) {
				imageSlide.scrollTo({
					left: imageSlide.scrollLeft - itemDistance,
					behavior: "smooth"
				});
			}
		});

		// Check overflow
		function checkOverflow() {
			const hasOverflow = imageSlide.scrollWidth > imageSlide.offsetWidth;
			prevNextButtonWrapper.classList.toggle("no-overflow", !hasOverflow);
		}
		checkOverflow();
		window.addEventListener("resize", checkOverflow);
	});
}
